// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.scss\"","facebookColor":"#1877f2","button":"FacebookButton_button__2X1aU","text":"FacebookButton_text__wtuhs"};